import { Outlet } from 'react-router';
import { useWorkspace } from '../../modules/stores';
import { I18nProvider } from '../../shared/i18n/I18nProvider';
import { WorkspaceIdentityProvider } from '../../shared/workspace/WorkspaceIdentity';
export function LocaleLayout() {
  const { region, store } = useWorkspace();
  return <WorkspaceIdentityProvider storeName={store?.name}><I18nProvider region={region}><Outlet /></I18nProvider></WorkspaceIdentityProvider>;
}
